'use strict';
const mmWidgets = require('../../widgets/mm-widgets'),
	MeasuresContent = require('../../models/measures-content'),
	MeasuresActivatedNodesFilter = require('../../models/measures-activated-nodes-filter'),
	MeasuresModel = require('../../models/measures-model');

require('../../widgets/measures-export-widget');
require('../../widgets/add-measure-widget');
require('../../widgets/measures-sheet-widget');
require('../../widgets/context-disabler-widget');

module.exports = function measuresStart(config, collaborationModel, mapModel, navigatorShim) {
	const measuresContent = new MeasuresContent(collaborationModel, 'measurements-config', 'measurements'),
		defaultFilter = new MeasuresActivatedNodesFilter(mapModel),
		measuresModel = new MeasuresModel(measuresContent, mapModel, defaultFilter),
		initialiseWidgets = function (options) {
			mmWidgets('[data-mm-measures-context]').contextDisablerWidget(measuresModel, 'measuresContext', 'data-mm-measures-context');
			mmWidgets('#measuresSheet').measuresSheetWidget(measuresModel, options);
			mmWidgets('[data-mm-role~="measure-add"]').addMeasureWidget(measuresModel);
			mmWidgets('[data-mm-role~="measures-exporter"]').measuresExportWidget(measuresModel, navigatorShim);
		};
	return {
		measuresContent: measuresContent,
		measuresModel: measuresModel,
		initialiseWidgets: initialiseWidgets
	};
};
